<template>
    <modal @close="$emit('close')" maxWidth="550px" width="95%">
        <div slot="title">{{$t('general.track_order')}}</div>
        <div slot="footer" class="py-2 px-3 d-flex">
            <div class="flex-grow-1 text-right">
                <button v-if="!searched" class="btn btn-sm btn-primary" @click="getBookings" >{{$t('general.track_order')}}</button>
                <button v-else class="btn btn-sm btn-primary" @click="getBookingsAgain" >{{$t('general.track_order_again')}}</button>
            </div>
        </div>
        <div class="container">
            <div v-if="!searched" class="pt-3 px-2">
                <div class="form-group row">
                    <label class="col-sm-12">{{$t('message.phone')}}</label>
                    <div class="col-sm-12">
                        <vue-phone-input
                            name="phone"
                            ref="phone-input"
                            :value="phoneNumber"
                            :code="countryCode"
                            :onChange="onPhoneNumberChange"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-12">{{$t('message.email')}}</label>
                    <div class="col-sm-12">
                        <input type="text" name="email" autocomplete="email" class="form-control" v-model="email" :placeholder="$t('enter_email_for_booking')">
                    </div>
                    <div v-if="warningText" class="warning-text col-12 pt-2">{{warningText}}</div>
                </div>
            </div>
            <customer-bookings v-else :context="context" :provider="provider" :guestBookingsArgs="trackOrderArgs" @error="getBookingsError" />
        </div>
    </modal>
</template>

<script>
import { mapActions } from 'vuex';
import Modal from './common/Modal.vue';
import vuePhoneInput from '../components/vue-phone-input/index.vue';
import { EventTrackOrder } from '../bu/models/GA4';
import { isValidPhoneNumber } from 'libphonenumber-js';
import Constants from '../constants';

export default {
    components: { Modal, vuePhoneInput },
    props: ['provider', 'context'],
    data() {
        return {
            searched: false,
            countryCode: 'tw',
            phoneCallingCode: '',
            phoneNumber: '',
            email: '',
            trackOrderArgs: null,
            warningText: ''
        }
    },
    computed: {
        hasValidPhoneCallingCode() {
            return !!this.phoneCallingCode && !!this.countryCode;
        },
        hasValidPhoneNumber() {
            return !!this.countryCode && isValidPhoneNumber(this.phoneNumber, this.countryCode?.toUpperCase());
        },
        hasValidEmail() {
            return this.email && this.email.match(Constants.validator.email);
        },
    },
    methods: {
        ...mapActions({
            getGuestBookings: 'customer/getGuestBookings'
        }),
        onPhoneNumberChange(phoneInputComponent) {
            this.phoneNumber = phoneInputComponent.phoneNumber;
            this.phoneCallingCode = new String( phoneInputComponent.availableData[phoneInputComponent.countryCode].dialCode);
            this.countryCode = phoneInputComponent.countryCode;
        },
        getBookings() {
            if (!this.hasValidPhoneCallingCode || !this.hasValidPhoneNumber || !this.hasValidEmail) {
                this.warningText = this.$t('message.no_track_order_input');
                return;
            }
            this.warningText = '';
            this.trackOrderArgs = {
                phoneCallingCode: this.phoneCallingCode,
                phoneNumber: this.phoneNumber,
                email: this.email
            }
            this.searched = true;
            this.trackTrackOrder();
        },
        getBookingsAgain() {
            this.countryCode = 'tw';
            this.phoneNumber = '';
            this.phoneCallingCode = ''
            this.email = ''
            this.warningText = '';
            this.searched = false;
        },
        getBookingsError() {
            this.searched = false;
            this.warningText = this.$t('message.no_customer_found');
        },
        trackTrackOrder() {
            window.tracker.track(() => new EventTrackOrder());
        }
    }
}
</script>

<style scoped lang="scss">
    /deep/ .intl-phone-input {
        width: 100%;
    }

    /deep/ .intl-phone-input .country-list {
        max-height: 100px;
    }

    .warning-text {
        text-align: center;
        color: red;
        font-size: 14px;
        margin: 8px;
    }
</style>

<i18n>
    {
        "en": {
            "enter_email_for_booking": "Enter email left for booking"
        },
        "zh": {
            "enter_email_for_booking": "輸入預約時填寫的 email"
        }
    }
</i18n>